import { ICambioProducto } from '../../../dto/ContractDTO'
import { axiosInstanceContratos } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'

export const getProductosContrato = async (tenant: ITenant) =>
  axiosInstanceContratos.get(`/contratos/${tenant.path}/productos?size=100&page=0`)

export const cambiarProductoContrato = async (idContrato: number, nuevoProducto: ICambioProducto) => {
  return await axiosInstanceContratos.post(`/contratos/${idContrato}/cambiar-producto`, nuevoProducto)
}
